'use client';

import 'swiper/css';
import 'swiper/css/a11y';
import { A11y, Mousewheel } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import BoundedIcon from '@/components/shared/BoundedIcon';
import { iconNames } from '@/components/shared/Icon';
import cn from '@/lib/cn';

export default function Shortfacts({
  className = undefined,
  entries,
}: {
  className?: string;
  entries: {
    _key: string;
    icon: string;
    title: string;
    text: string;
  }[];
}) {
  return (
    <Swiper
      className={cn('!-mx-0.5 !overflow-visible overscroll-contain', className)}
      grabCursor
      modules={[A11y, Mousewheel]}
      mousewheel={{
        forceToAxis: true,
      }}
      slidesPerView="auto"
    >
      {entries.map((entry) => (
        <SwiperSlide
          key={entry._key}
          className="!w-auto min-w-[18.75rem] grow px-0.5"
        >
          <div className="border-t border-white/15 pt-6 pr-4.5">
            <BoundedIcon
              background="white"
              name={entry.icon as (typeof iconNames)[number]}
              size="md"
            />

            <p className="mt-3 max-w-72 text-xs font-semibold md:text-sm">
              {entry.title}
            </p>

            <p className="mt-2 max-w-72 text-white/80">{entry.text}</p>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
